export enum JobPriority {
    Critical = 'critical',
    High = 'high',
    Medium = 'medium',
    Low = 'low',
  }